import React from "react";
import PropTypes from "prop-types";
import styled from "styled-components";

const ColumnWrapper = styled.div`
  display: flex;
  flex: 1 1 0px;
  flex-flow: column nowrap;
  justify-content: flex-start;
  background-color: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "#fff"};
  color: ${(props) => (props.textColor ? props.textColor : "")};
`;

export default function Column(props) {
  const wrapperProps = {};
  if (props.align) {
    wrapperProps["style"] = {
      ...wrapperProps["style"],
      justifyContent:
        props.align === "bottom"
          ? "flex-end"
          : props.align === "center"
          ? "center"
          : "flex-top",
    };
  }
  return (
    <ColumnWrapper
      data-block={props.name}
      {...wrapperProps}
      backgroundColor={props.backgroundColor}
      textColor={props.textColor}
    >
      {props.extraPadding ? (
        <div style={{ padding: "40px" }}>{props.children}</div>
      ) : (
        <>{props.children}</>
      )}
    </ColumnWrapper>
  );
}

Column.propTypes = {
  children: PropTypes.node,
  align: PropTypes.string,
  name: PropTypes.string,
  backgroundColor: PropTypes.string,
  textColor: PropTypes.string,
  extraPadding: PropTypes.bool,
};

Column.defaultProps = {
  children: undefined,
  align: "flex-start",
  name: undefined,
  backgroundColor: undefined,
  textColor: undefined,
  extraPadding: undefined,
};
